module.exports = __webpack_public_path__ + "static/media/levelZermatt.e6c1ad97.jpg";